/** Field operations entries in the portal menu (wording kept with the module). */
export const FIELD_NAV = {
  myShifts: { label: "My shifts", hint: "Your job packs" },
  incidents: { label: "Incidents", hint: "Reports and near misses" },
  missingTicketsBadge: (n: number) => `${n} rostered without a ticket they need`,
} as const;
